import { getPath, endpoints } from "./apiUtils";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../useAuth";

export const listCaregivers = (params) => {
  let path = getPath({
    endpoint: endpoints.caregivers,
    queryParameters: params,
  });
  return axios.get(path).then((r) => r.data);
};

export const useCaregiver = (userId) => {
  let path = getPath({
    endpoint: endpoints.caregivers,
    path: [userId],
  });

  return useQuery(
    ["caregivers", userId],
    async () => axios.get(path).then((r) => r.data),
    { enabled: !!userId }
  );
};

export const useCaregivers = (params) => {
  const path = getPath({
    endpoint: endpoints.caregivers,
    queryParameters: params,
  });
  let stuff = [];
  if (params) {
    Object.keys(params).forEach((p) => {
      stuff.push(p);
      stuff.push(params[p]);
    });
  }

  // https://tanstack.com/query/v3/docs/react/guides/infinite-queries
  return useQuery(
    ["caregivers", stuff],
    async () => axios.get(path).then((r) => r.data),
    {
      keepPreviousData: true,
    }
  );
};

export const useCaregiverApplication = () => {
  const { user, getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.caregivers,
    path: [user?.UserId, "application"],
  });

  return useQuery(
    ["caregivers", user?.UserId, "application"],
    async () =>
      axios
        .get(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data),
    { enabled: !!user }
  );
};

export const useCaregiverMutation = () => {
  const { user, getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.caregivers,
    path: [user?.UserId],
  });

  return useMutation(async (data) =>
    axios
      .post(path, data, { headers: { Authorization: await getAccessToken() } })
      .then((r) => r.data)
  );
};

export const useCaregiverSchedule = (caregiverId, timezone) => {
  const { getAccessToken } = useContext(AuthContext);

  const path = getPath({
    endpoint: endpoints.caregivers,
    path: [caregiverId, "schedule"],
    queryParameters: { userTimezone: timezone },
  });

  return useQuery(
    ["caregiver-schedule", caregiverId],
    async () =>
      axios
        .get(path, { headers: { Authorization: await getAccessToken() } })
        .then((r) => r.data),
    {
      enabled: !!caregiverId,
    }
  );
};
